module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {


if (!bannerPath) var bannerPath='';
if (!title) var title = '';
;
__p += '\r\n<section class="ny-banner container">\r\n  <div class="bg-img bg-cover" style="background-image: url(' +
((__t = ( bannerPath )) == null ? '' : __t) +
');"></div>\r\n  <div class="layout">\r\n    <div class="t">\r\n      <h1>' +
((__t = ( title )) == null ? '' : __t) +
'</h1>\r\n      <h2 class="wowtext">' +
((__t = ( title )) == null ? '' : __t) +
'</h2>\r\n    </div>\r\n  </div>\r\n</section>';

}
return __p
}